import {
    Component,
    Material,
    Mesh,
    MeshComponent,
    Object3D,
    Scene,
    WonderlandEngine,
} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {SurfaceSampler} from './surface-sampler.js';
import {quat, vec3} from 'gl-matrix';
import {AnimateFlower} from './animate-flower.js';

/**
 * scatter-spawn
 */
export class ScatterSpawn extends Component {
    static TypeName = 'scatter-spawn';

    /* Properties that are configurable in the editor */
    @property.mesh()
    scatterMesh!: Mesh;
    @property.material()
    scatterMaterial!: Material;
    @property.float(0.3)
    minScale!: number; // Minimum scale value
    @property.float(1)
    maxScale!: number; // Maximum scale value

    @property.int(10)
    count!: number;

    @property.bool(true)
    animate: boolean;

    @property.bool(true)
    animate: boolean;

    static onRegister(engine: WonderlandEngine) {
        engine.registerComponent(SurfaceSampler);
        // DEBUG
        engine.registerComponent(AnimateFlower);
    }

    init() {}

    start() {
        const mesh = this.object.getComponent(MeshComponent);
        if (!mesh) {
            console.warn('Mesh is required for scatter-spawn component!');
            return;
        }

        const surfaceSampler = this.object.addComponent(SurfaceSampler, {
            mesh: mesh.mesh,
        });
        const position = vec3.create();
        const normal = vec3.create();

        const componentCountHint = this.animate ? this.count * 3 : this.count * 2;
        const children = this.engine.scene.addObjects(
            this.count,
            this.object,
            componentCountHint
        );
        const upWorld = this.object.getUpWorld(vec3.create());
        const rotation = quat.create();

        for (const child of children) {
            child.addComponent(MeshComponent, {
                mesh: this.scatterMesh,
                material: this.scatterMaterial,
            });
            surfaceSampler.sample(position, normal);
            child.setPositionLocal(position);

            // Generate a random scale within the specified range
            const randomScale =
                Math.random() * (this.maxScale - this.minScale) + this.minScale;
            child.setScalingLocal([randomScale, randomScale, randomScale]);
            child.setRotationWorld(quat.rotationTo(rotation, upWorld, normal));

            if (this.animate) {
                child.addComponent(AnimateFlower, {
                    fullScale: randomScale,
                });
            }
        }
    }

    update(dt: number) {
        /* Called every frame. */
    }
}
